import { useMutation } from "react-query";
import { customApi } from "../../../../../CustomHoock/CustomApi";

export const useGetDesignerOrderDesignHistoryChart = () => {
  return useMutation(["GetDesignerOrderDesignHistoryChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetDesignerOrderDesignHistoryChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};
export const useGetDesignerAverageOrderDesignHistoryChart = () => {
  return useMutation(["GetDesignerAverageOrderDesignHistoryChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetDesignerAverageOrderDesignHistoryChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};
